export default __webpack_public_path__ + "static/subclass-void-84d995.png";